<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <h2>
          Uredite {{ companyTypeName === 'Distributors' ? 'distributerja' : 'stranko' }} {{ company.name }}:
        </h2>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="toggleActive"
        >
          {{ company.is_active ? 'Deaktiviraj' : 'Aktiviraj' }}
          <v-icon right dark>mdi-{{ company.is_active ? 'cancel' : 'check' }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <ClientsFormEdit
      @save="save"
      @cancel="cancel"
      :client="company"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ClientsFormEdit from '@/components/ClientsFormEdit'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    ClientsFormEdit
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    },
    companyTypeName: {
      required: true,
      type: String
    }
  },
  computed: {
    company () {
      return this.$store.state.companies.childCompanies[this.id]
    }
  },
  methods: {
    ...mapActions('companies', ['loadChildCompany', 'updateCompany', 'setCompanyActiveStatus']),
    save ({ data }) {
      this.updateCompany({ id: this.id, ...data })
        .then(company => {
          this.$router.push({ name: this.companyTypeName })
        })
    },
    cancel () {
      this.$router.push({ name: this.companyTypeName })
    },
    toggleActive () {
      this.setCompanyActiveStatus({ id: this.company.id, active: !this.company.is_active })
    }
  },
  created () {
    this.loadChildCompany(this.id)
      .then(company => { this.asyncDataStatus_fetched() })
  }
}
</script>
